// Cravy About - Hero v2: separate photo/video for desktop and for mobile, each with a focal point.
// Registered as data-slice="hero2". The original `hero` component in cravy-about1.js is untouched:
// remove the <script> tag for this file from sections/cr-about-hero.liquid and set data-slice back
// to "hero" to restore the old behaviour.
// Uses globals from cravy-about1.js: React, useMob, H, P, PAD.
(function () {
  window.CravyAbout = window.CravyAbout || {};

  function pickSrc(list) {
    var mp = (list || []).filter(function (s) { return s && s.f === 'mp4' && s.url; })
      .sort(function (a, b) { return a.h - b.h; });
    if (!mp.length) return '';
    for (var i = 0; i < mp.length; i++) if (mp[i].h >= 720) return mp[i].url;
    return mp[mp.length - 1].url;
  }

  function HeroVideo(props) {
    var ref = React.useRef(null);
    React.useEffect(function () {
      var v = ref.current;
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }, [props.src]);
    return React.createElement('video', {
      ref: ref, src: props.src, poster: props.poster || undefined,
      muted: true, loop: true, autoPlay: true, playsInline: true, preload: 'auto',
      style: {
        position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover',
        objectPosition: props.pos, opacity: props.opacity, display: 'block'
      }
    });
  }

  function AboutHero2(props) {
    var h = React.createElement;
    var c = props.cfg || {};
    var m = useMob();
    var jump = function (href) {
      return function (e) {
        if (href && href.charAt(0) === '#') {
          var t = document.getElementById(href.slice(1));
          if (t) {
            e.preventDefault();
            window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
          }
        }
      };
    };
    var bg = P(c.bg, 'var(--cravy-red)'), text = P(c.text, '#fff'), accent = P(c.accent, 'var(--cravy-yellow)');
    var b1 = P(c.btn1_link, '#process'), b2 = P(c.btn2_link, '#inquiry');

    // choose the device set; mobile falls back to the desktop media when its own is empty
    var d = {
      media: P(c.d_media, 'photo'), img: P(c.d_img, ''), vid: pickSrc(c.d_vid), poster: P(c.d_poster, ''),
      x: Number(P(c.d_x, 50)), y: Number(P(c.d_y, 50))
    };
    var mo = {
      media: P(c.m_media, 'photo'), img: P(c.m_img, ''), vid: pickSrc(c.m_vid), poster: P(c.m_poster, ''),
      x: Number(P(c.m_x, 50)), y: Number(P(c.m_y, 50))
    };
    var useM = m && (mo.img || mo.vid);
    var s = useM ? mo : d;
    var wantVideo = s.media === 'video' && !!s.vid;
    var pos = s.x + '% ' + s.y + '%';
    var op = Number(P(c.img_opacity, 1));

    return h('section', {
      id: 'about-hero', 'data-screen-label': 'About hero',
      style: {
        position: 'relative', minHeight: m ? '92svh' : '100vh', background: bg, overflow: 'hidden',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'
      }
    },
    wantVideo
      ? h(HeroVideo, { src: s.vid, poster: s.poster || s.img, pos: pos, opacity: op })
      : (s.img ? h('img', {
        src: s.img, alt: '',
        style: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: pos, opacity: op }
      }) : null),
    h('div', { style: { position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0) 60%)' } }),
    h('div', {
      style: { position: 'relative', padding: '0 ' + PAD + ' clamp(48px,9vh,110px)', display: 'flex', flexDirection: 'column', gap: 'clamp(14px,2vh,26px)' }
    },
    h('h1', {
      className: 'fadein-1', style: { color: text, textShadow: '0 2px 24px rgba(0,0,0,0.35)' },
      dangerouslySetInnerHTML: H(P(c.heading, 'We are\nCravy'))
    }),
    h('p', {
      className: 'fadein-2',
      style: { margin: 0, maxWidth: 620, fontFamily: 'var(--font-body)', fontSize: 'clamp(16px,1.35vw,21px)', lineHeight: 1.35, color: text },
      dangerouslySetInnerHTML: H(P(c.body, ''))
    }),
    h('div', { className: 'fadein-3', style: { display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 6 } },
      h('a', {
        className: 'herobtn herobtn-lite', href: b1, onClick: jump(b1),
        style: { textDecoration: 'none', fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: 15, letterSpacing: '0.04em', textTransform: 'uppercase', padding: '15px 30px', background: '#fff', color: '#000', borderRadius: 999 }
      }, P(c.btn1_text, 'How we make them')),
      h('a', {
        className: 'herobtn', href: b2, onClick: jump(b2),
        style: { textDecoration: 'none', fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: 15, letterSpacing: '0.04em', textTransform: 'uppercase', padding: '15px 30px', background: accent, color: '#000', borderRadius: 999 }
      }, P(c.btn2_text, 'Become a partner')))));
  }
  window.CravyAbout.hero2 = AboutHero2;
})();
